export default {
    en: {
        title: "Inventory Count List",
        date: 'Date',
        total: 'Total Products',
        missing: 'Missing Items',
        extra: 'Extra Products',
        newBtn: 'New Inventory Count',
        newIn: {
            title: "Inventory List",
            total: "Total",
            name: "Name",
            code: 'Code',
            size: "Size",
            quantity: "Quantity",
            check: 'Checked',
            show: 'Show Scanner',
            hide: 'Hide Scanner',
            subTitle: 'Are there any not counted items?',
            subQuantity: "Items Quantity",
            save: 'Save Result',
            msg: "Inventory Counting is finished"
        }
    },
    uz: {
        title: "Inventarizatsiya ro'yxati",
        date: 'Sana',
        total: 'Umumiy Mahsulotlar',
        missing: "Yo'qolgan Mahsulotlar",
        extra: 'Ortiqcha Mahsulotlar',
        newBtn: 'Yangi Inventarizatsiya',
        newIn: {
            title: "Inventarizatsiya ro'yxati",
            total: "Jami",
            name: "Nomi",
            code: 'Kod',
            size: "O'lchami",
            quantity: "Miqdori",
            check: 'Tekshirildi',
            show: "Skanerni Ko'rsatish",
            hide: "Skanerni Yashirish",
            subTitle: "Ortib qolgan mahsulot bormi?",
            subQuantity: "Miqdori",
            save: "Natijani Saqlash",
            msg: "Inventarizatsiya muvaffaqiyatli yakunlandi"
        }
    },
    ru: {
        title: "Список инвентаризации",
        date: 'Дата',
        total: 'Всего продуктов',
        missing: 'Недостающие продукты',
        extra: 'Превышенные продукты',
        newBtn: 'Новый инвентаризации',
        newIn: {
            title: "Список инвентаризации",
            total: "Всего",
            name: "Название",
            code: 'Код',
            size: "Размер",
            quantity: "Количество",
            check: 'Проверено',
            show: 'Показать сканер',
            hide: 'Скрыть сканер',
            subTitle: 'есть ли не посчитанный продукт?',
            subQuantity: "Количество",
            save: 'Сохранить результат',
            msg: "Инвентаризация успешно завершена"
        }
    }
}